/*! JointJS+ v4.2.2 (2026-01-22) - HTML5 Diagramming Framework

Copyright (c) 2025 client IO

This Source Code Form is subject to the terms of the JointJS+
License, v. 2.0. If a copy of the JointJS+ License was not
distributed with this file, You can obtain one at
https://www.jointjs.com/license or from the JointJS+ archive as was
distributed by client IO. See the LICENSE file.
*/
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var OPEN_SANS_URL = './assets/fonts/OpenSans.ttf';
var DM_SANS_URL = './assets/fonts/DMSans.ttf';
var ROBOTO_FLEX_URL = './assets/fonts/RobotoFlex.ttf';
function base64convert(file) {
    return new Promise(function (resolve, reject) {
        var reader = new FileReader();
        reader.onload = function () {
            resolve(reader.result);
        };
        reader.onerror = reject;
        reader.readAsDataURL(file);
    });
}
export var fontsStyleSheet = function () { return __awaiter(void 0, void 0, void 0, function () {
    var openSans, openSansBase64, _a, dmSans, dmSansBase64, _b, robotoFlex, robotoFlexBase64, _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0: return [4 /*yield*/, fetch(OPEN_SANS_URL)];
            case 1:
                openSans = _d.sent();
                _a = base64convert;
                return [4 /*yield*/, openSans.blob()];
            case 2: return [4 /*yield*/, _a.apply(void 0, [_d.sent()])];
            case 3:
                openSansBase64 = _d.sent();
                return [4 /*yield*/, fetch(DM_SANS_URL)];
            case 4:
                dmSans = _d.sent();
                _b = base64convert;
                return [4 /*yield*/, dmSans.blob()];
            case 5: return [4 /*yield*/, _b.apply(void 0, [_d.sent()])];
            case 6:
                dmSansBase64 = _d.sent();
                return [4 /*yield*/, fetch(ROBOTO_FLEX_URL)];
            case 7:
                robotoFlex = _d.sent();
                _c = base64convert;
                return [4 /*yield*/, robotoFlex.blob()];
            case 8: return [4 /*yield*/, _c.apply(void 0, [_d.sent()])];
            case 9:
                robotoFlexBase64 = _d.sent();
                // font-face declarations to be used when exporting
                return [2 /*return*/, "\n    @font-face {\n        font-family: 'Open Sans';\n        font-stretch: 75% 125%;\n        font-style: normal;\n        font-weight: 125 950;\n        src: url(".concat(openSansBase64, ") format('truetype');\n    }\n\n    @font-face {\n        font-family: 'DM Sans';\n        font-stretch: 75% 125%;\n        font-style: italic;\n        font-weight: 125 950;\n        src: url(").concat(dmSansBase64, ") format('truetype');\n    }\n\n    @font-face {\n        font-family: 'Roboto Flex';\n        font-stretch: 75% 125%;\n        font-style: normal;\n        font-weight: 125 950;\n        src: url(").concat(robotoFlexBase64, ") format('truetype');\n    }\n    ")];
        }
    });
}); };
